import { en } from '@formkit/i18n';
import { defineFormKitConfig } from '@formkit/vue';
import { generateClasses } from '@formkit/themes';
import { genesisIcons } from '@formkit/icons';

// PRO
import { createProPlugin, inputs } from '@formkit/pro';
const pro = createProPlugin('fk-606d61424fd', inputs);
import myTailwindTheme from './tailwind-theme.js'; // change to your theme's path

export default defineFormKitConfig(() => {
  return {
    locales: { en },
    locale: 'en',
    icons: {
      ...genesisIcons,
    },
    plugins: [pro],
    config: {
      classes: generateClasses(myTailwindTheme),
    },
  };
});
